import { PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'
import qs from 'qs'

const { get, post, del } = createClient()

/* API request to get user */
export async function getUserRequest() {
  const { data } = await get(`${PUBLIC_BASE_URL}/me`)
  return data
}

/* API request to update user subscriptions */
export function getMySubscriptionsRequest() {
  const query = { game_id: GAME_ID }
  return requestAll(`${PUBLIC_BASE_URL}/me/subscribed${queryString(query)}`)
}

/* API request to get user's ratings */
export function getAllUserRatings(query = {}) {
  query.game_id = GAME_ID
  return requestAll(`${PUBLIC_BASE_URL}/me/ratings${queryString(query)}`)
}

/* API request to subscribe to mod */
export function subscribeToModRequest({ gameId, modId } = {}) {
  return post(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/subscribe`,
    qs.stringify({ noop: 'noop' })
  )
}

/* API request to unsubscribe to mod */
export async function unsubscribeToModRequest({ gameId, modId } = {}) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/subscribe`
  )
  return data
}

/* API request to update to mod rating */
export function updateModRatingRequest({ gameId, modId, rating } = {}) {
  return post(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/ratings`,
    qs.stringify({ rating })
  )
}

/* API request get user details */
export async function getPublicUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`

  const { data } = await get(`${PUBLIC_BASE_URL}/users/${id}`)
  return data
}

/* API request to follow a user */
export function subscribeToUserRequest(currentUser, user_id) {
  return post(
    `${PUBLIC_BASE_URL}/users/${currentUser}/following`,
    qs.stringify({ user_id })
  )
}

/* API request to unfollow a user */
export function unsubscribeFromUserRequest(currentUser, userId) {
  return del(`${PUBLIC_BASE_URL}/users/${currentUser}/following/${userId}`)
}

/* API request to get my followings */
export async function getMyUserFollowingsRequest() {
  const { data } = await get(`${PUBLIC_BASE_URL}/me/following`)
  return data
}

/* API request get user's followers */
export async function getPublicUserFollowersRequest(nameId) {
  const { data } = await get(`${PUBLIC_BASE_URL}/users/@${nameId}/followers`)
  return data
}

/* API request get user's followings */
export async function getPublicUserFollowingsRequest(nameId) {
  const { data } = await get(`${PUBLIC_BASE_URL}/users/@${nameId}/following`)
  return data
}

/* API request to get user's followed collections */
export function getMyFollowedCollectionsRequest() {
  const query = { game_id: GAME_ID }
  return requestAll(
    `${PUBLIC_BASE_URL}/me/following/collections${queryString(query)}`
  )
}

/* API request to update to collection compatibility rating */
export async function updateCollectionCompatibilityRequest({
  collectionNameId,
  rating,
} = {}) {
  await post(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/compatibility`,
    qs.stringify({ rating })
  )
}

/* API request to get the age widget */
export async function getAgeWidgetRequest() {
  const { data } = await get(`${PUBLIC_BASE_URL}/widgets/age-gate`)
  return data
}

/* API request to mute the specified user */
export async function muteUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`
  const { data } = await post(`${PUBLIC_BASE_URL}/users/${id}/mute`)
  return data
}

/* API request to unmute the specified user */
export async function unmuteUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`
  const { data } = await del(`${PUBLIC_BASE_URL}/users/${id}/mute`)
  return data
}

/* API request to get list of muted users for current user */
export async function getMyMutedUsersRequest() {
  // _limit=999 bypasses pagination and returns all users
  const { data } = await get(`${PUBLIC_BASE_URL}/me/users/muted?_limit=999`)
  return data
}

/* API request to block the specified user */
export async function blockUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`
  const { data } = await post(`${PUBLIC_BASE_URL}/cogs/users/${id}/blocks`)
  return data
}

/* API request to unblock the specified user */
export async function unblockUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`
  const { data } = await del(`${PUBLIC_BASE_URL}/cogs/users/${id}/blocks`)
  return data
}

/* API request to get list of blocked users for current user */
export async function getMyBlockedUsersRequest(userId) {
  // _limit=999 bypasses pagination and returns all users
  const id = Number.isInteger(userId) ? userId : `@${userId}`
  const { data } = await get(
    `${PUBLIC_BASE_URL}/cogs/users/${id}/blocks?_limit=999`
  )
  return data
}

/* API request to get the users purchased mods */
export function getMyPurchasesRequest() {
  const query = { game_id: GAME_ID }
  return requestAll(`${PUBLIC_BASE_URL}/me/purchased${queryString(query)}`)
}
